<template>
    <div v-if="temAcessoAtualizarRateioEmMassa">
        <rateios-atualizar-em-massa
            :itens="itens"
            :unidades="unidades"
            :projetos="projetos"
            :acoes="acoes"
            @obterUnidades="obterUnidades()"
            @obterAcoes="obterAcoes($event)"
            @obterProjetos="obterProjetos($event)"
            @salvarRateios="salvarRateiosEmMassa($event)"
        ></rateios-atualizar-em-massa>
        <router-view></router-view>
    </div>
</template>

<script>
import RateiosAtualizarEmMassa from './../../componentes/rateios/RateiosAtualizarEmMassa.vue';
import ItensDespesasServicos from './../itensDespesas/ItensDespesasServicos'
import RateiosServicos from './RateiosServicos';

export default {
    components: {
        RateiosAtualizarEmMassa
    },

    data() {
        return {
            itens: [],
            unidades: [],
            projetos: [],
            acoes: []
        }
    },

    methods: {
        obterItens() {
            this.$store.dispatch('addRequest')
            let idsItensDto = {
                itensIds: this.$route.params.idsItens
            }
            ItensDespesasServicos.obterItens(idsItensDto).then(response => {
                if (response) {
                    if (response.success) {
                        this.itens = response.data
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    } 
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterUnidades() {
            this.$store.dispatch('addRequest')
            RateiosServicos.obterUnidades().then(response => {
                if (response) {
                    if (response.success) {
                        this.unidades = response.data
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterProjetos(evento) {
            this.$store.dispatch('addRequest')
            RateiosServicos.obterProjetos(evento.codUnidade).then(response => {
                if (response) {
                    if (response.success) {
                        this.projetos = response.data
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterAcoes(evento){
            this.$store.dispatch('addRequest')
            RateiosServicos.obterAcoes(evento.codUnidade, evento.codProjeto).then(response => {
                if (response) {
                    if (response.success) {
                        this.acoes = response.data
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        salvarRateiosEmMassa(rateios) {
            let rateiosDto = {
                itensId: this.$route.params.idsItens,
                rateios: rateios
            }
            this.$store.dispatch('addRequest')
            RateiosServicos.salvarRateiosEmMassa(rateiosDto).then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Rateios atualizados com sucesso',
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$store.dispatch('setRecarregar', true)
                        this.$router.go(-1)
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    created() {
        this.obterItens()
    },

    computed: {
        temAcessoAtualizarRateioEmMassa() {
            return this.$route.name == 'DespesasGerais_Requisitantes_Despesas_AtualizarRateiosEmMassa'
                && this.$temAcessoView('DESP-GERAIS-REQ-03')
        },
    }
}

</script>